module.exports = __webpack_public_path__ + "img/js.ece8391d.svg";